import styled from 'styled-components';
import { IFrameBase } from './interface';

const base = styled.div<IFrameBase>`
  display: ${(props) => (props.isActive ? 'flex' : 'none')};
  grid-area: ${(props) => (props.gridArea ? props.gridArea : '')};
  flex-direction: column;
  justify-content: center;
  flex-grow: ${(props) => (props.flexGrow ? props.flexGrow : 'none')};
  align-items: center;
  width: ${(props) => (props.maxWidth ? 'auto' : props.width)};
  min-width: ${(props) => (props.minWidth ? props.minWidth : 'auto')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'auto')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  min-height: ${(props) => (props.minHeight ? props.minHeight : 'none')};
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : 'none')};
  margin: ${(props) => (props.margin ? props.margin : '0rem')};
  padding: ${(props) => (props.padding ? props.padding : 0)};
  font-family: parisineclair-regular, Arial, Helvetica, sans-serif;
  border: none;
  border-radius: ${(props) => props.theme.border.default};
  box-shadow: ${(props) => props.theme.shadow.default};
  transition-duration: ${(props) => props.theme.transitionDuration.default};
  background-color: ${(props) => props.theme.colors.white};
`;

const Frame = {
  Base: base,
};

export default Frame;
